import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';

export default function MostraGravidade ({gravidade}) {
    
    if(gravidade !== undefined) {
        switch(gravidade){
            case 'ALTA':
                return <FaExclamationTriangle className='h-4 w-4 text-warning text-center font-extrabold' title='Grau de Violação: Grave'/>
            case 'MEDIA':
                return <FaExclamationTriangle className='h-4 w-4 text-danger text-center font-extrabold' title='Grau de Violação: Moderada'/>
            case 'BAIXA':
                return <FaExclamationTriangle className='h-4 w-4 text-alerta text-center font-extrabold' title='Grau de Violação: Leve'/>
            default:
                return <FaExclamationTriangle className='h-4 w-4 text-background text-center font-extrabold' title='Não possui Grau de Violação'/>
        }
    }else 
        return <FaExclamationTriangle className='h-4 w-4 text-background text-center font-extrabold' title='Não possui Grau de Violaçãoe'/>
}